import ReducersTooling from '../../../tooling/reducersTooling';

const initialState = {
  reset: ReducersTooling.initialStates.getFetchTypeInitialState()
};


export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/resetPassword/initialState.js